import { render } from "./ArticleTable.vue?vue&type=template&id=57d06a3e&scoped=true"
import script from "./ArticleTable.vue?vue&type=script&lang=js"
export * from "./ArticleTable.vue?vue&type=script&lang=js"

import "./ArticleTable.vue?vue&type=style&index=0&id=57d06a3e&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d06a3e"]])

export default __exports__